import { graphql, useStaticQuery } from "gatsby"
import { TNavigation } from "../types"

const v2mainmenu = (): TNavigation => {

  const query = useStaticQuery(
    graphql`
      query {
        allNavigation(filter: { title: { eq: "V2 Main Menu" } }) {
          nodes {
            title
            json
          }
        }
      }
    `)

  return query.allNavigation.nodes[0]

}

export default v2mainmenu
